module.exports = __webpack_public_path__ + "static/media/Somod_logo1.b87a1f1e.png";